<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <ul class="entrance_ul intro">
          <h3>个人信息</h3>
          <li>
            <span>姓名：</span>
            <div class="answer">
              <p>{{inforList.realname}}</p>
            </div>
          </li>
          <li>
            <span>手机号：</span>
            <div class="answer">
              <p>{{inforList.phone}}</p>
            </div>
          </li>
          <li>
            <span>身份证号：</span>
            <div class="answer">
              <p>{{inforList.idcard}}</p>
            </div>
          </li>
          <li>
            <span>文化程度：</span>
            <div class="answer">
              <el-select v-model="inforList.degree" disabled>
                <el-option
                  v-for="item in configArr.degree"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <span>学员类型：</span>
              <div class="answer">
              <el-select v-model="inforList.category" disabled>
                <el-option :label="item.name" :value="item.id" v-for="item in studentTypeArr" :key="item.id"></el-option>
              </el-select>
            </div>
          </li>
          <li v-if="inforList.specialty">
            <span>专业：</span>
            <div class="answer">
              <p>{{inforList.specialty}}</p>
            </div>
          </li>
          <li v-if="inforList.nation">
            <span>民族：</span>
            <div class="answer">
              <el-select v-model="inforList.nation" disabled>
                <el-option :label="item.name" :value="item.id" v-for="item in configArr.nation" :key="item.id"></el-option>
              </el-select>
            </div>
          </li>
        </ul>
        <ul class="entrance_ul">
          <h3>个人简历</h3>
          <li>
            <span>工作状态：</span>
            <div class="answer">
              <el-radio v-model="detailList.person_work" disabled 
                v-for="item in studentConfig.person_work"
                :key="item.id"
                :label="item.id"
                :value="item.id">{{item.name}}</el-radio>
                <p v-if="detailList.person_work === 10">{{detailList.person_work_other}}</p>
            </div>
          </li>
          <li>
            <span>工作年限：</span>
            <div class="answer">
              <el-radio v-model="detailList.person_worktime" disabled 
                v-for="item in studentConfig.person_worktime"
                :key="item.id"
                :label="item.id"
                :value="item.id">{{item.name}}</el-radio>
            </div>
          </li>
          <li>
            <span>职位级别：</span>
            <div class="answer">
              <el-radio v-model="detailList.person_position" disabled 
                v-for="item in studentConfig.person_position"
                :key="item.id"
                :label="item.id"
                :value="item.id">{{item.name}}</el-radio>
            </div>
          </li>
          <li>
            <span>岗位名称：</span>
            <div class="answer">
              <p>{{detailList.person_station}}</p>
            </div>
          </li>
        </ul>
        <ul class="entrance_ul fill_in">
          <h3>创业信息</h3>
          <li>
            <span>创业动机：</span>
            <div class="answer">
              <el-checkbox v-model="detailList.motive_category" disabled 
                v-for="item in studentConfig.motive_category"
                :key="item.id"
                :label="item.id"
                :checked="item.checked"
                :value="item.id">{{item.name}}</el-checkbox>
                <p v-if="motiveCategoryShow" class="other_text">{{detailList.motive_other}}</p>
            </div>
          </li>  
          <li>
            <span>是否有具体的创业思路：</span>
            <div class="answer">
              <el-radio v-model="detailList.design_category" disabled 
                v-for="item in studentConfig.design_category"
                :key="item.id"
                :label="item.id"
                :value="item.id">{{item.name}}</el-radio>
                <p v-if="detailList.design_category === 1" class="other_text">{{detailList.design_other}}</p>
            </div>
          </li> 
          <li>
            <span>创办企业名称：</span>
            <div class="answer">
              <p>{{detailList.company_name}}</p>
            </div>
          </li> 
          <li>
            <span>主要经营范围：</span>
            <div class="answer">
              <p>{{detailList.manage_scope}}</p>
            </div>
          </li> 
          <li>
            <span>经营地址：</span>
            <div class="answer">
              <p>{{detailList.manage_address}}</p>
            </div>
          </li> 
          <li>
            <span>开业时间：</span>
            <div class="answer">
              <p>{{detailList.open_time}}</p>
            </div>
          </li> 
          <li>
            <span>雇佣员工人数：</span>
            <div class="answer">
              <p>{{detailList.staff_num}}</p>
            </div>
          </li> 
          <li>
            <span>经济组织类型：</span>
            <div class="answer">
              <el-radio v-model="detailList.company_type" disabled 
                v-for="item in studentConfig.company_type"
                :key="item.id"
                :label="item.id"
                :value="item.id">{{item.name}}</el-radio>
            </div>
          </li> 
          <li>
            <span>经营项目类型：</span>
            <div class="answer">
              <el-checkbox v-model="detailList.manage_category" disabled 
                v-for="item in studentConfig.manage_category"
                :key="item.id"
                :label="item.id"
                :checked="item.checked"
                :value="item.id">{{item.name}}</el-checkbox>
                <p v-if="manageCategoryShow" class="other_text">{{detailList.manage_other}}</p>
            </div>
          </li> 
          <li>
            <span>参加培训的目的：</span>
            <div class="answer">
              <el-checkbox v-model="detailList.join_purpose" disabled 
                v-for="item in studentConfig.join_purpose"
                :key="item.id"
                :label="item.id"
                :checked="item.checked"
                :value="item.id">{{item.name}}</el-checkbox>
                <p v-if="joinPurposeShow" class="other_text">{{detailList.purpose_ohter}}</p>
            </div>
          </li>  
          <li>
            <span>在培训班的期望：</span>
            <div class="answer">
              <el-checkbox v-model="detailList.study_purpose" disabled 
                v-for="item in studentConfig.study_purpose"
                :key="item.id"
                :label="item.id"
                :checked="item.checked"
                :value="item.id">{{item.name}}</el-checkbox>
                <p v-if="studyPurposeShow" class="other_text">{{detailList.study_ohter}}</p>
            </div>
          </li>  
        </ul>
        <ul class="entrance_ul entrance_btn" v-if="showCheck">
            <li>
              <span>审核状态：</span>
              <div class="answer">
                <el-radio
                  v-model="entranceRadio"
                  v-for="(item,index) in entranceList"
                  :key="index"
                  :label="item.id"
                  :checked="item.checked"
                  :disabled="item.disabled"
                  @change="changeEntranceForm(index+1)"
                  :value="item.id">{{item.name}}
                </el-radio>
              </div>
            </li>
            <li  v-if="showNoReson" >
              <span>审核原因：</span>
              <div class="answer">
                <el-input type="textarea" v-model="entranceReson" :disabled="!check_status"></el-input>
              </div>
            </li>
            <li v-if="check_status " class="answer_btn">
              <span></span>
              <div class="answer" >
                <el-button type="primary" @click="entranceSubmit">提交审核</el-button>
              </div>
            </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'entranceForm',
    data(){
      return {
        detailList:{},
        inforList:{},
        configArr:[],
        studentTypeArr:[],
        studentConfig:{},
        entranceForm:{},
        entranceRadio:0,
        entranceReson:'',
        showNoReson:false,
        detailBoolean:false,
        manageCategoryShow:false,
        motiveCategoryShow:false,
        joinPurposeShow:false,
        studyPurposeShow:false,
        check_status:false,
        showCheck:true,
        entranceList:[
          {
            name:'通过',id:1,checked:false,disabled:false
          },{
            name:'不通过',id:2,checked:false,disabled:false
          },
        ]
      }
    },
    created(){
      this.id = this.$route.params && this.$route.params.id
      this.status = Number(this.$route.query.status)
      // this.period_id = Number(this.$route.query.id)
      this.studentTypeArr = JSON.parse(this.$store.state.student_type) || JSON.parse(localStorage.getItem('student_type'))
      let inforParams = {
        student_id:Number(this.id)
      }
      this.getInfor(inforParams)
      this.getDetail(inforParams)
      
    },
    mounted(){
      
    },
    methods:{
      getInfor(params){
        this.$api.user.detailStudent(params)
        .then(res=>{
          if(res.code === 0){
            this.inforList = res.result
            if(this.inforList.category === 0){
              this.inforList.category = ''
            }
          }
        }) 
      },
      getDetail(params){
        this.$api.user.getEnrollment(params)
        .then(res=>{
          if(res.code === 0){
            this.showCheck = true
            this.detailBoolean = true
            this.detailList = res.result
            this.entranceReson = this.detailList.check_reson
            this.entranceForm.reson = this.detailList.check_reson
            if(this.detailList.check_status === 10){
              this.entranceList[0].checked = true
              this.entranceList[0].disabled = true
              this.entranceList[1].disabled = true
              this.check_status = false
              this.entranceRadio = 1
              this.showNoReson = false
            }else if(this.detailList.check_status === 5){
              this.check_status = true
              this.entranceList[2].checked = true
              this.entranceRadio = 2
            }else{
              this.check_status = true
              this.entranceList[0].checked = true
              this.entranceRadio = 1
            }
          }else if(res.code === 1010){
            this.showCheck = false
          }
          this.obtainDegree()
        }) 
      },
      obtainDegree(){
        this.$api.user.getConfig()
        .then(res=>{
          if(res.code === 0){
            this.configArr = res.result
            this.studentConfig = res.result.student_record
            if(this.detailBoolean){
              this.studentConfig.manage_category.forEach((v) => {
                v.checked = false
                if(this.detailList.manage_category.indexOf(String(v.id)) != -1){
                  v.checked = true
                }
                if(this.detailList.manage_category.indexOf('10') != -1){
                  this.manageCategoryShow = true
                }
              });
              this.studentConfig.motive_category.forEach((v) => {
                v.checked = false
                if(this.detailList.motive_category.indexOf(String(v.id)) != -1){
                  v.checked = true
                }
                if(this.detailList.motive_category.indexOf('10') != -1){
                  this.motiveCategoryShow = true
                }
              });
              this.studentConfig.join_purpose.forEach((v) => {
                v.checked = false
                if(this.detailList.join_purpose.indexOf(String(v.id)) != -1){
                  v.checked = true
                }
                if(this.detailList.join_purpose.indexOf('10') != -1){
                  this.joinPurposeShow = true
                }
              });
              this.studentConfig.study_purpose.forEach((v) => {
                v.checked = false
                if(this.detailList.study_purpose.indexOf(String(v.id)) != -1){
                  v.checked = true
                }
                if(this.detailList.study_purpose.indexOf('10') != -1){
                  this.studyPurposeShow = true
                }
              });
            }
          }
        }) 
      },
      changeEntranceForm(val){
        if(val === 2){
          this.showNoReson = true
        }else{
          this.showNoReson = false
        }
      },
      entranceSubmit(){
        let params = {
          student_id:this.id,
          status:this.entranceRadio,
          reson:this.entranceReson
        }
        if(this.entranceRadio){
          this.$api.user.recordExamine(params)
          .then(res=>{
            if(res.code === 0){
              this.$message.success('审核成功')
              let inforParams = {
                student_id:Number(this.id)
              }
              this.getInfor(inforParams)
              this.getDetail(inforParams)
              // this.$router.push({
              //   path:'/period/periodStudent/' + this.period_id
              // })
            }
          }) 
        }else{
          this.$message.error('请选择审核状态')
        }
      },
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../../assets/scss/content.scss';
  @import '../../../assets/scss/entranceForm.scss';
</style>